import { rwdMenuSpacingForTitle, Text as TextComponent } from '@billy/design-system'
import styled from '@emotion/styled'
import cc from 'classcat'
import React, { ReactNode } from 'react'

import { reactClass } from '../../../utils'
import * as Styled from './styles'

export type HeaderProps = {
  children?: ReactNode
  className?: string
  title?: ReactNode
  withMargin?: boolean
}

const Text = styled(TextComponent)`
  ${rwdMenuSpacingForTitle}
`

export const Header = ({ children, className, title, withMargin }: HeaderProps) => (
  <Styled.HeaderWrapper className={cc([className, reactClass('header')])} withMargin={withMargin}>
    {typeof title === 'string' ? (
      <Text variant="h1" truncate>
        {title}
      </Text>
    ) : (
      title || null
    )}
    <Styled.SideHeaderWrapper>{children}</Styled.SideHeaderWrapper>
  </Styled.HeaderWrapper>
)
